import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import {Menu, Dropdown, Button, Form, Popover, Input, Select} from 'antd'
import TableComponent from 'components/Table'
import SelectField from 'components/SelectField'
import SortableColumn from 'components/Table/ColumnSort'
import SearchableColumn from 'components/Table/ColumnSearch'
import NextModal from 'components/NextModal'
import Icon, { CloseOutlined, SearchOutlined } from '@ant-design/icons'
import { TransferStatus } from '../TransfersStatus'
import {
  TabsInfoIco,
  AccountMoreIco,
} from '../../../../modules/CustomIcons'
import './index.scss'
import '../index.scss'
import { useTranslation } from 'react-i18next'
import {Tooltip} from 'antd'
import { modalRender, typeRender } from 'pages/Transfers/TypeStatusRender'
import { getTransfersDetail } from '../../../services/transfers'
import { renderTextforBatch } from 'pages/Transfers/StatusRender'
import CustomTooltip from 'components/Tooltip'
import {Scrollbar} from "smooth-scrollbar-react"
import { start } from 'repl'
const currencyFilter = [
  {
    label: 'AZN',
    value: 1,
  },
  {
    label: 'AZN',
    value: 2,
  },
]
const codeOptions = [
  {
    label: 'IM',
    value: 1,
  },
  {
    label: 'IT',
    value: 2,
  },
  {
    label: 'FX',
    value: 3,
  },
  {
    label: 'AZ',
    value: 4,
  },
  {
    label: 'XT',
    value: 5,
  },
  {
    label: 'XV',
    value: 2,
  },
  {
    label: 'XV',
    value: 6,
  },
  {
    label: 'SP',
    value: 7,
  },
]


const tableData = [
  {
    key: '1',
    date: '01.11.2021  14:32',
    userName: 'yusifh',
    transferWork: 'İmza/təsdiq üçün göndərilibdir',
    status: 'İmza və təsdiq üçün gözləyir',
  },
  {
    key: '1',
    date: '01.11.2021  14:32',
    userName: 'yusifh',
    transferWork: 'İmza/təsdiq üçün göndərilibdir',
    status: 'İmza və təsdiq üçün gözləyir',
  },
  {
    key: '1',
    date: '01.11.2021  14:32',
    userName: 'yusifh',
    transferWork: 'İmza/təsdiq üçün göndərilibdir',
    status: 'İmza və təsdiq üçün gözləyir',
  },
  {
    key: '1',
    date: '01.11.2021  14:32',
    userName: 'yusifh',
    transferWork: 'İmza/təsdiq üçün göndərilibdir',
    status: 'İmza və təsdiq üçün gözləyir',
  },
]

const InnerTable: React.FC<any> = (props) => {
  const {t} = useTranslation()
  const [form] = Form.useForm()

  const tableDropDown = (
    <Menu className="hesablar_dropdown hesablar_dropdown--transfers">
      <Menu.Item icon={<Icon component={() => <TabsInfoIco />} />}>
        <Link to={'/'}>{t("salary.errorReport")}</Link>
      </Menu.Item>
    </Menu>
  )
  
  const columnsData = [
    {
      title: t("common.date"),
      dataIndex: 'transactionDate',
      key: 'transactionDate',
      editable: false,
    },
    {
      title: t("login.userName"),
      dataIndex: 'userName',
      key: 'userName',
      editable: false,
    },
    {
      title: t("transfers.actionWithTransaction"),
      dataIndex: 'trnStatusBeforeStr',
      key: 'trnStatusBeforeStr',
      editable: false,
    },
    {
      title: t("transfers.acquiredStatus"),
      dataIndex: 'trnStatusAfterStr',
      key: 'trnStatusAfterStr',
    },
  ]
  const [nextModalVisible, setNextModalVisible] = useState(false)
  const [codeValue, setCodeValue] = useState(0);
  const [filtereValues, setFilteredValues] = useState({ "code": "", "docNumber": "", "receiver": "","currency":"", "mainDetail":"","assignment":"","status":"" })
  const [tableList, setTableFilterList] = useState(props.innerData)
  const [tableListForSortOriginal, setTableListForSortOriginal] = useState<any>();
  const [searchable, setSearchable] = useState(false)
  const [currency,setCurrencyFilter]= useState([])
  const [statusList,setStatusList]= useState([])
  const [modalType, setModalType] = useState('')
  const [modalDataSingle, setModalDataSingle] = useState({})
  const [current, setCurrent] = useState(1)
  const [type,setType] =useState([])
  const [detailDataState, setDetailData] = useState({})
  const [historyList, setHistoryList] = useState([]);
  const [docNumber,setDocNumber]= useState('')
  const [inputValue, setInputValue] = useState("");
  const [noHover, setHover] = useState(false)
  const [openStatus, setOpenStatus] = useState(false);
  const [codeSelect,setcodeSelect] = useState('')
 
  

  const codeCreateHandle = (data:any)=>{
    setTableListForSortOriginal(data)
    setTableFilterList(data)
      let temp_currency:any = [{ label: t("common.all"), value: 'all' }];
      let temp_status:any = [{ label: t("common.all"), value: 'all' }];
     data?.map((item:any) =>{

         let check_currency = temp_currency.find(row => row.value == item.currency && item.currency!== undefined);
        
         if(!check_currency && item.currency!==null){

           temp_currency.push({
           label:item.currency,
           value:item.currency
         })}
         let check_status = temp_status.find(row => row.value == item.status && item.status!== undefined);

         if(!check_status && item.status!==null){
          const statusLabel = renderTextforBatch(item.status)
          temp_status.push({
           label:statusLabel,
           value:item.status
         })}
       
     });
    setStatusList(temp_status)
     setCurrencyFilter(temp_currency);
     let temp_type:any = [{ label: t("common.all"), value: 'all' }];

     data?.map((item:any) =>{
  
         let check_type = temp_type.find(row => row.value == item.code && item.code!== undefined);
      
         if(!check_type && item.code!==null){
          temp_type.push({
           label:item.code,
           value:item.code
         })}
       
     });

     setType(temp_type);
  }
  
  useEffect(()=>{
    codeCreateHandle(props.innerData)
  },[props.innerData])

  const handleFilterChange= (e:any,column:any)=>{
    let newfiltereValues = filtereValues;


    if (column === 'code') {
      newfiltereValues.code = e?.toLowerCase() ;
      newfiltereValues.docNumber = ''
      newfiltereValues.currency = ''
      newfiltereValues.assignment = ''
      form.setFieldsValue({"docNumber": ""})
      form.setFieldsValue({"receiver": ""})
      form.setFieldsValue({"currency": ""})
      form.setFieldsValue({"assignment":''})
      setcodeSelect(e?.toLowerCase())
      setFilteredValues(newfiltereValues)
    }

    if (column === 'docNumber') {
      newfiltereValues.docNumber = e.target.value?.toLowerCase()
      newfiltereValues.code = ''
      newfiltereValues.currency = ''
      newfiltereValues.assignment = ''
      form.setFieldsValue({"code": ""})
      form.setFieldsValue({"receiver": ""})
      form.setFieldsValue({"currency": ""})
      form.setFieldsValue({"assignment": ""})
      setcodeSelect('')

      setFilteredValues(newfiltereValues)
    }

    if (column === 'receiver') {
      newfiltereValues.receiver = e.target.value?.toLowerCase()
      newfiltereValues.code = ''
      newfiltereValues.docNumber = ''
      newfiltereValues.currency = ''
      newfiltereValues.assignment = ''
      form.setFieldsValue({"code": ""})
      form.setFieldsValue({"docNumber": ""})
      form.setFieldsValue({"currency": ""})
      form.setFieldsValue({"assignment": ""})
      setFilteredValues(newfiltereValues)
      setcodeSelect('')

    }

    if(column === "currency"){

      newfiltereValues.currency=e?.toLowerCase()
      newfiltereValues.receiver = ''
      newfiltereValues.code = ''
      newfiltereValues.docNumber = ''
      newfiltereValues.assignment = ''
      form.setFieldsValue({"receiver": ""})
      form.setFieldsValue({"code": ""})
      form.setFieldsValue({"docNumber": ""})
      form.setFieldsValue({"assignment": ""})
      setFilteredValues(newfiltereValues)
      setcodeSelect('')

    }
    if(column === "assignment"){

      newfiltereValues.assignment=e.target.value?.toLowerCase()
      newfiltereValues.currency = ''
      newfiltereValues.receiver = ''
      newfiltereValues.code = ''
      newfiltereValues.docNumber = ''
      form.setFieldsValue({"currency": ""})
      form.setFieldsValue({"receiver": ""})
      form.setFieldsValue({"code": ""})
      form.setFieldsValue({"docNumber": ""})
      setcodeSelect('')

      setFilteredValues(newfiltereValues)
    } 
    if(column === "mainDetail"){

      newfiltereValues.mainDetail=e.target.value?.toLowerCase()
      newfiltereValues.currency = ''
      newfiltereValues.receiver = ''
      newfiltereValues.code = ''
      newfiltereValues.docNumber = ''
      form.setFieldsValue({"currency": ""})
      form.setFieldsValue({"receiver": ""})
      form.setFieldsValue({"code": ""})
      setcodeSelect('')

      form.setFieldsValue({"docNumber": ""})
      setFilteredValues(newfiltereValues)
    } 
    if(column === "status"){
      newfiltereValues.status = e?.toLowerCase()
      newfiltereValues.assignment=
      newfiltereValues.currency = ''
      newfiltereValues.receiver = ''
      newfiltereValues.code = ''
      newfiltereValues.docNumber = ''
      form.setFieldsValue({"currency": ""})
      form.setFieldsValue({"receiver": ""})
      form.setFieldsValue({"code": ""})
      setcodeSelect('')

      form.setFieldsValue({"docNumber": ""})
      setFilteredValues(newfiltereValues)
    }
    if (tableList && filtereValues) {

      let filteredData: any;
     
      filteredData = tableListForSortOriginal?.filter((sRow: any) =>
              (sRow.docNumber ? sRow.docNumber?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').
              includes(filtereValues["docNumber"]) : filtereValues["docNumber"] === '' ? sRow.docNumber === null : "")
              && 
              (sRow.code ? sRow.code?.toLowerCase().normalize().
              replace(/[\u0300-\u036f]/g, '').includes(filtereValues["code"]) : filtereValues["code"] === '' ? sRow.code === null : "")
              &&
              (sRow.currency ? sRow.currency?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["currency"]) :
                      filtereValues["currency"] === '' ? sRow.currency === null :""
              )&&
              (sRow.status ? sRow.status?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["status"]) :
              filtereValues["status"] === '' ? sRow.status === null :"")
      
              &&
              (sRow.receiver ? sRow.receiver?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["receiver"]) :
                      filtereValues["receiver"] === '' ? sRow.receiver === null :""
              )
              &&
              (sRow.assignment ? sRow.assignment?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["assignment"]) :
                      filtereValues["assignment"] === '' ? sRow.assignment === null :""
              )
              &&
              (sRow.mainDetail ? sRow.mainDetail?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["mainDetail"]) :
              filtereValues["mainDetail"] === '' ? sRow.mainDetail === null :""
      )
            )
         
      setTableFilterList(old_data => filteredData);

      //     &&
      //     (sRow.trnTypeStr ? sRow.trnTypeStr?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["transferType"]) :
      //         filtereValues["transferType"] === '' ? sRow.trnTypeStr === null : ""));
      // setTableFilterList(old_data => filteredData);

      if (filtereValues["currency"] === 'all') {
        setTableFilterList(tableListForSortOriginal)
        form.setFieldsValue({"status": ""})
        form.setFieldsValue({"code": ""})
      }
      if (filtereValues["code"] === 'all') {
        setTableFilterList(tableListForSortOriginal)
        form.setFieldsValue({"currency": ""})
        form.setFieldsValue({"status": ""})

      }
      if (filtereValues["status"] === 'all') {
        setTableFilterList(tableListForSortOriginal)
        form.setFieldsValue({"currency": ""})
        form.setFieldsValue({"code": ""})
      
      }


    }


  }

  const handleRowClick =async (record) =>{

    const findRow = tableList.find(row=>row.docNumber === record.docNumber)

    if(findRow.ibankref)
    {
      try{
      let detailData = await getTransfersDetail(findRow.ibankref)


          setDocNumber(findRow.ibankref)
          setModalType(findRow.code)

        let modalDataS :any = await modalRender(findRow.code, detailData)
        console.log(modalDataS)
        if(modalDataS !== null && modalDataS !== undefined){
          setModalDataSingle(modalDataS)
          setDetailData(detailData)
          const cashHistory: Array<any> = []
          if (detailData !== undefined && detailData !== null && detailData?.ibankRef !== null) {
            detailData['HISTORY_DETAILS'].map((item: any) => {
              cashHistory.push({
                transactionDate: item.transactionDate + ' ' + item.transactionTime,
                userName: item.userName,
                trnStatusBeforeStr: item.trnStatusBeforeStr,
                trnStatusAfterStr: item.trnStatusAfterStr
              });
            });
            setHistoryList(cashHistory)
            setNextModalVisible(true)
          }else{
            setNextModalVisible(false)
          }
          }

      }catch{
        setNextModalVisible(false)

      }
    
    
  }
  }

  const innerColumnsData = [
    {
      title: <div className="flex">№</div>,
      editable: false,
      dataIndex: 'key',
      ellipsis : true,
      width: 40,
      key: 'key',
      sorter: (a: any, b: any) => a.key - b.key,
      render:(text:any,record:any)=>{
       
        const key = Number(text.replace(`${"/"+record.PMTID+"/"+record.packageNumber}`,'')) + 1
     
        return(
          <Tooltip style={{left:'30%'}} title={key}>
            {key}
          </Tooltip>
        )
      }
    },
    {
      title: (          
          <div >
           <p style={{ textAlign: 'left',color: '#747a83', fontSize: '12px' }}>
           {t("requisites.code")}

          </p>
          <Select
            name={"code"}
            placeholder={t("common.all")}
            options={type}
            className="column-select inner--table__select"
            onChange={(e: any) => handleFilterChange(e,"code")}
          />
            
        </div>
          
          
      ),
      ellipsis : true,
      dataIndex: 'code',
      key: 'code',
      width: 85,
      editable: false,
      render: (text:any) => <div style={{ textAlign: 'left' }}>{text}</div>,
    },
    {
      title: (
        <div
          className="searchable-column inner_columns"
          // style={{ marginLeft: -25 }}
        >
            <Input
                // form={form}
              
                style={{backgroundColor:"white",borderRadius:20,height:19,fontSize:12}}
                filter={'searchfilter'}
                placeholder={t("salary.documentNo")}
                name={"documentNo"}
                onChange={(value: any) => handleFilterChange(value,"docNumber")}
                allowClear
                suffix={
                  filtereValues.docNumber ? (
                    ""
                  ) : (
                    <SearchOutlined />
                  )
                }
            />
        </div>
      ),
      dataIndex: 'docNumber',
      key: 'docNumber',
      width: 130,

      ellipsis : true,
      render: (text, record) => {
        
        if(record.ibankref===null){
          return <p
            // style={{ marginLeft: -30, padding: 0 }}
          >{text}
          </p>

        }else{
          return <a onClick={() =>{handleRowClick(record)}}>{text}</a>
        }
      },
      editable: false,
    },
    {
      title: (
        <div className="searchable-column inner_columns">
          <div className={'flex'}>
            <Input
             style={{backgroundColor:"white",borderRadius:20,height:19,fontSize:12}}
                large
                innerClass={'column-header__search ant-input'}
                // form={form}
                filter={'searchfilter'}
                name={'receiver'}
                onChange={(event: any) => handleFilterChange(event, 'receiver')}
                placeholder={t("common.beneficiary")}
                allowClear
          
                suffix={
                  filtereValues.receiver ? (
                    ""
                  ) : (
                    <SearchOutlined />
                  )
                }
            />
          </div>
        </div>
      ),
      dataIndex: 'receiver',
      key: 'receiver',
      ellipsis: true,
      width: 170,
      editable: false,
      render: (text: any) => {
        if (text?.length > 25) {
          const truncatedText = text.slice(0, 25) + '...';
  
          return (
            <Tooltip className="transfers-tooltip" title={text} placement="top">
              <span>{truncatedText}</span>
            </Tooltip>
          );
        } else {
          return <span>{text}</span>;
        }
      }
    },
    //   render: (text: string, record: any) => {
    // 
    //     return (
    //       
    //         <Tooltip className="transfers-tooltip" title={text} placement="top" >
    //           <Button
    //             type="ghost"
    //             className="transparent"
    //           />
    //           <p>{text}</p>
    //         </Tooltip>
    //       
    //     )
    //   }
   
    {
      title: (
        <div className="searchable-column">
          <SortableColumn
              name={"amount_filter"}
              data={tableList}
              setData={setTableFilterList}
              dataOriginal={tableListForSortOriginal}
              type={"number"}
              parameter={"amount"}
           // paramater_second={"amount"}
          />
          {t("common.amount")}
        </div>
      ),
      dataIndex: 'amount',
      key: 'amount',
      width: 105,
      ellipsis : true,
      editable: false,
      // sorter: (a: any, b: any) => a.amount - b.amount,
      render: (text:any) => <div style={{ textAlign: 'right' }}>{text}</div>,
    },
    {
      title: (
        <div >
           <p style={{ textAlign: 'left',color: '#747a83', fontSize: '12px' }}>
           {t("home.currency")}
          </p>
          <SelectField
              name={"currency"}
              placeholder={t("common.all")}
            options={currency}
            className="column-select inner--table__select"
              onChange={(e: any) => handleFilterChange(e,"currency")}
          />
        </div>
      ),
      dataIndex: 'currency',
      key: 'currency',
      width: 100,
      ellipsis : true,
      editable: false,
      render: (text:any) => <div style={{ textAlign: 'left' }}>{text}</div>,
    }, 
    {
      title: (
        <div className="searchable-column inner_columns">
          {/* <div className="searchable-column__inner"> */}
            <Input
            style={{backgroundColor:"white",borderRadius:20,height:19,fontSize:12}}
                name={"mainDetail"}
                innerClass={'column-header__search ant-input'}
                placeholder={t("accountStatement.mainPayment")}
                onChange={(value: any) => handleFilterChange(value,"mainDetail")}
                allowClear
                suffix={
                  filtereValues.mainDetail ? (
                    ""
                  ) : (
                    <SearchOutlined />
                  )
                }
            />
          {/* </div> */}
        </div>
      ),
      dataIndex: 'mainDetail',
      key: 'mainDetail',
      width: 140,
      ellipsis : true,
      editable: false,
      render:(text:any,record:any)=>{
        if(text?.length>25 ){
          return (
          <CustomTooltip
          placement ="top"
          title={text}>
                          <p >{text}</p>

          </CustomTooltip>)
        }else{
          return text
        }
        
      }
    },
    {
      title: (
        <div className="searchable-column inner_columns">
          {/* <div className="searchable-column__inner"> */}
            <Input
            style={{backgroundColor:"white",borderRadius:20,height:19,fontSize:12}}
                name={"assignment"}
                placeholder={t("home.paymentDetailsBT")}
                onChange={(value: any) => handleFilterChange(value,"assignment")}
                allowClear
                suffix={
                  filtereValues.assignment ? (
                    ""
                  ) : (
                    <SearchOutlined  
                   
                    />
                  )
                }
            />
          {/* </div> */}
        </div>
      ),
      dataIndex: 'assignment',
      key: 'assignment',
      width: 180,
      ellipsis : true,
      editable: false,
      render:(text:any,record:any)=>{
        if(text?.length>25 ){
          return (
          <CustomTooltip
          placement ="top"
          title={text?.replace(record.mainDetail,'')}>
                          <p>{text?.replace(record.mainDetail,'')}</p>

          </CustomTooltip>)
        }else{
          return text?.replace(record.mainDetail,'')
        }

      }
    },
    {
      title: (
      
          
        <div
          style={{
            // marginLeft: 15,
          }}
        >
          <p style={{ textAlign: 'left', fontSize: '12px', width: 120, marginBottom: '7px'}}>
            {"Status"}
          </p>
            <SelectField
              // open={false}
              placeholder={t('common.all')}
              // width={170}
              value={filtereValues['status']}
              name={"status_filter"}
              options={statusList}
              // defaultActiveFirstOption={true}
              // dropdownClassName="mass-status-select"
               className="column-select inner--table__select"
              onChange={(value: String) => handleFilterChange(value, 'status')}
            />
           </div>
            
          
      
      ),
      dataIndex: 'status',
      key: 'status',
      width: 190,
      minWidth: 125,
      ellipsis: true,
      render: (text: string, record: any) => {

        return(

        <TransferStatus
          statusValue={record?.status}
          statusType={record?.status}
        />
      )},
      editable: false,
    },
    {
      title: '',
      key: '',
      dataIndex: '',
      width: 60,
      ellipsis : true,
      render: (text, record) => {
   
        return (

          <a>
            <Popover
              // visible={true}
              className=' mass-transfer-popover'
              placement="topRight"
              overlayClassName="mass-transfer-popover"
              content={
               
                <div className='manage_faster_menus swift_modal form_next_modal' style={{ width: 540 }}>
                   <Scrollbar  
                    damping={0.1}
                thumbMinSize={20}
                renderByPixels={true}
                continuousScrolling={true}
                style={{ width: 540, height: 'auto', maxHeight: '400px' }}> 

                  <table className={`table table-hover swift_table form_next_table`}>
                    
                    <tbody>
                    
                   
                      {
                        record.modalData?.map((line) => {
                          if(record.checkMessageDetails?.length > 0  && record.checkMessageDetails?.find((r:any)=> r.key === line.code)){
                            let value =''
                            let index =0
                                record.checkMessageDetails?.filter((r:any)=> r.key === line.code).map((r:any)=>{

                                   value += index !== record.checkMessageDetails?.filter((r:any)=> r.key === line.code).length-1 ? r.value +"," : r.value
                                  index++
                                })
                            return (
                              <tr>
                                <td style={{color:'#F3646C'}}>{line.label}</td>
                                <td style={{color:'#F3646C'}}>{value}</td>
                              </tr>
                            )  
                          }else
                          {return (
                            <tr>
                              <td>{line.label}</td>
                              <td>{line.value}</td>
                            </tr>
                          )}
                        })
                      }
                    
                    </tbody>
                  </table>
                  </Scrollbar>
                </div>
           
              }
            >
              <Button
                className="transparent"
                style={{ width: '100%' }}
                icon={<TabsInfoIco />}
              />
            </Popover>
          </a>
        
        )
      },
    },
    // {
    //   title: '',
    //   key: 'action',
    //   ellipsis : true,
    //   width: 50,
    //   className: 'account_action_col',
    //   render: (text, record) => (
    //     <Dropdown
    //       overlay={tableDropDown}
    //       trigger={'click'}
    //       placement="topCenter"
    //       disabled={record.status!=="BATCH_CHECK_ERROR"}
    //     >
    //       <Button
    //         icon={<AccountMoreIco />}
    //         className="transparent table_more_btn"
    //       />
    //     </Dropdown>
    //   ),
    // },
  ]
  let modalData = {
    modalTitle: t("transfers.transferDetails"),
    groups: [
      {
        title: false,
        tableHasBorderBottom: true,
        data: [
          {
            label: t("transfers.sourceOfCreation"),
            value: 'Kütləvi yüklənmə',
          },
          {
            label: t("transfers.transferType"),
            value: 'AZİPS',
          },
          {
            label: t("home.company"),
            value: 'VALUE SERVICES MMC ŞİRKƏTİ',
          },
          {
            label: t("home.company"),
            value: 'VALUE SERVICES MMC ŞİRKƏTİ',
          },
          {
            label: t("transfers.fromAccount"),
            value: 'AZ78BRES00380394400262924501 AZN',
          },
        ],
      },
      {
        title: t("requisites.beneficiary"),
        tableHasBorderBottom2: true,
        tableHasMarginBottom: true,
        data: [
          {
            label: t("requisites.code"),
            value: '506924',
          },
          {
            label: t("requisites.name"),
            value: 'Bank of Baku ASC',
          },
          {
            label: t("common.amount"),
            value: '2.02 AZN',
          },
          {
            label: t("home.commission"),
            value: '1.00 AZN',
          },
          {
            label: t("accountStatement.paymentDetails"),
            value: 'Müqavilə üzrə AZİPS köçürməsi',
          },
          {
            label: t("transfers.infoForBeneficiary"),
            value: 'SALAM',
          },
          {
            label: t("newTransfer.note"),
            value: 'SALAM',
          },
        ],
      },
    ],
    buttons: {
      cancelButton: true,
    },
  }
  const innerrtableData = [
    {
        key: '1',
        date: '01.11.2021  14:32',
        userName: 'yusifh',
        notification: 'Göndərilmədi. Xahiş edirik, yenidən göndərəsiniz.',
    }
  ]
  const innerColumnsdata = [
    {
        title: t("common.date"),
        dataIndex: 'transactionDate',
        key: 'transactionDate',
        editable: false,
    },
    {
        title: t("login.userName"),
        dataIndex: 'userName',
        key: 'userName',
        editable: false,
    },
    {
        title: t("transfers.notes"),
        dataIndex: 'notification',
        key: 'notification',
        editable: false,
    },
  ]
  const rowSelection = {
    columnWidth: 40,
    right: 10,
  }
  return (
    <>
      {nextModalVisible && <NextModal
          visible={nextModalVisible}
          data={modalDataSingle}
          tableTitle={t("transfers.transferHistory")}
          columnsData={columnsData}
          tableData={historyList}
          pdfLoading={props.pdfLoading}
          handleGetFileClick={(e) => props.handleGetFileClick(e, docNumber)}
          onClose={(e) => setNextModalVisible(e)}
          transferData
          historyList={historyList}
          batchtransfer={true}
          className={'no_footer_line mass-transfer-inner-modal modalTransferDetail'}

      />}
      <TableComponent
        columns={innerColumnsData}
        rowSelection = {props.rowSelection}
        className='transfer-table transfer-table--mass salary-table inner_table_mass transfers-table__component'
        data={tableList}
        pageSize={props.pageSize}
        scroll={{ x: '100%' }}
        id="innerTable"
          pagination={true}
          onPageChange={(page: number) => setCurrent(page)}
          current={current}
          // pageSize={pageSize}
        position="bottom center"
      />
    </>
  )
}
export default InnerTable
